import { default as _91_46_46_46cms_93PbQgByhHt9Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93fkX0R4CL13Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexMtgHI4qrcnMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93N7illcbVeKMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/akcii/[...slug].vue?macro=true";
import { default as indexls2oiJinKVMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_935GdkiHSSCtMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/articles/[...slug].vue?macro=true";
import { default as indexrSM9Llisg9Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/articles/index.vue?macro=true";
import { default as indexEHCrxyRONiMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/authorization/index.vue?macro=true";
import { default as indexi9F4jLRBfvMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93miWlbxTn0dMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93pcSlxhkIydMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalog/[...slug].vue?macro=true";
import { default as indexYekYnU1y3qMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93iCs0FUUTt6Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultCyz5dFWOnnMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalogsearch/result.vue?macro=true";
import { default as index6uIRD8JshkMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93QnElhS8BMdMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93tfNNO5vsKpMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/fabriki/[...slug].vue?macro=true";
import { default as indexa5Sq5vCiW1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93aVVvl4QwAiMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_9301tQUponPaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/product/[...slug].vue?macro=true";
import { default as indexyhDiwH28E7Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/profile/index.vue?macro=true";
import { default as indexejKMk7xlgoMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/profile/orders/index.vue?macro=true";
import { default as indexq7YnPQbEg4Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93poC5JwtBGOMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/sets/[...slug].vue?macro=true";
import { default as indexmYV1DtVu0vMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93PbQgByhHt9Meta?.name ?? "cms",
    path: _91_46_46_46cms_93PbQgByhHt9Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93PbQgByhHt9Meta || {},
    alias: _91_46_46_46cms_93PbQgByhHt9Meta?.alias || [],
    redirect: _91_46_46_46cms_93PbQgByhHt9Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93fkX0R4CL13Meta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93fkX0R4CL13Meta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93fkX0R4CL13Meta || {},
    alias: _91_46_46_46slug_93fkX0R4CL13Meta?.alias || [],
    redirect: _91_46_46_46slug_93fkX0R4CL13Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexMtgHI4qrcnMeta?.name ?? "3d-projects",
    path: indexMtgHI4qrcnMeta?.path ?? "/3d-projects",
    meta: indexMtgHI4qrcnMeta || {},
    alias: indexMtgHI4qrcnMeta?.alias || [],
    redirect: indexMtgHI4qrcnMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93N7illcbVeKMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93N7illcbVeKMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93N7illcbVeKMeta || {},
    alias: _91_46_46_46slug_93N7illcbVeKMeta?.alias || [],
    redirect: _91_46_46_46slug_93N7illcbVeKMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexls2oiJinKVMeta?.name ?? "akcii",
    path: indexls2oiJinKVMeta?.path ?? "/akcii",
    meta: indexls2oiJinKVMeta || {},
    alias: indexls2oiJinKVMeta?.alias || [],
    redirect: indexls2oiJinKVMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_935GdkiHSSCtMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_935GdkiHSSCtMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_935GdkiHSSCtMeta || {},
    alias: _91_46_46_46slug_935GdkiHSSCtMeta?.alias || [],
    redirect: _91_46_46_46slug_935GdkiHSSCtMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexrSM9Llisg9Meta?.name ?? "articles",
    path: indexrSM9Llisg9Meta?.path ?? "/articles",
    meta: indexrSM9Llisg9Meta || {},
    alias: indexrSM9Llisg9Meta?.alias || [],
    redirect: indexrSM9Llisg9Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexEHCrxyRONiMeta?.name ?? "authorization",
    path: indexEHCrxyRONiMeta?.path ?? "/authorization",
    meta: indexEHCrxyRONiMeta || {},
    alias: indexEHCrxyRONiMeta?.alias || [],
    redirect: indexEHCrxyRONiMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexi9F4jLRBfvMeta?.name ?? "cart",
    path: indexi9F4jLRBfvMeta?.path ?? "/cart",
    meta: indexi9F4jLRBfvMeta || {},
    alias: indexi9F4jLRBfvMeta?.alias || [],
    redirect: indexi9F4jLRBfvMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93miWlbxTn0dMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93miWlbxTn0dMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93miWlbxTn0dMeta || {},
    alias: _91_46_46_46id_93miWlbxTn0dMeta?.alias || [],
    redirect: _91_46_46_46id_93miWlbxTn0dMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93pcSlxhkIydMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93pcSlxhkIydMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93pcSlxhkIydMeta || {},
    alias: _91_46_46_46slug_93pcSlxhkIydMeta?.alias || [],
    redirect: _91_46_46_46slug_93pcSlxhkIydMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexYekYnU1y3qMeta?.name ?? "catalog",
    path: indexYekYnU1y3qMeta?.path ?? "/catalog",
    meta: indexYekYnU1y3qMeta || {},
    alias: indexYekYnU1y3qMeta?.alias || [],
    redirect: indexYekYnU1y3qMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93iCs0FUUTt6Meta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93iCs0FUUTt6Meta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93iCs0FUUTt6Meta || {},
    alias: _91_46_46_46slug_93iCs0FUUTt6Meta?.alias || [],
    redirect: _91_46_46_46slug_93iCs0FUUTt6Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultCyz5dFWOnnMeta?.name ?? "catalogsearch-result",
    path: resultCyz5dFWOnnMeta?.path ?? "/catalogsearch/result",
    meta: resultCyz5dFWOnnMeta || {},
    alias: resultCyz5dFWOnnMeta?.alias || [],
    redirect: resultCyz5dFWOnnMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: index6uIRD8JshkMeta?.name ?? "clear-page-slider",
    path: index6uIRD8JshkMeta?.path ?? "/clear-page-slider",
    meta: index6uIRD8JshkMeta || {},
    alias: index6uIRD8JshkMeta?.alias || [],
    redirect: index6uIRD8JshkMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93QnElhS8BMdMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93QnElhS8BMdMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93QnElhS8BMdMeta || {},
    alias: _91_46_46_46slug_93QnElhS8BMdMeta?.alias || [],
    redirect: _91_46_46_46slug_93QnElhS8BMdMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93tfNNO5vsKpMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93tfNNO5vsKpMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93tfNNO5vsKpMeta || {},
    alias: _91_46_46_46slug_93tfNNO5vsKpMeta?.alias || [],
    redirect: _91_46_46_46slug_93tfNNO5vsKpMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexa5Sq5vCiW1Meta?.name ?? "fabriki",
    path: indexa5Sq5vCiW1Meta?.path ?? "/fabriki",
    meta: indexa5Sq5vCiW1Meta || {},
    alias: indexa5Sq5vCiW1Meta?.alias || [],
    redirect: indexa5Sq5vCiW1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93aVVvl4QwAiMeta?.name ?? "order-status-hash",
    path: _91hash_93aVVvl4QwAiMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93aVVvl4QwAiMeta || {},
    alias: _91hash_93aVVvl4QwAiMeta?.alias || [],
    redirect: _91hash_93aVVvl4QwAiMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_9301tQUponPaMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_9301tQUponPaMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_9301tQUponPaMeta || {},
    alias: _91_46_46_46slug_9301tQUponPaMeta?.alias || [],
    redirect: _91_46_46_46slug_9301tQUponPaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexyhDiwH28E7Meta?.name ?? "profile",
    path: indexyhDiwH28E7Meta?.path ?? "/profile",
    meta: indexyhDiwH28E7Meta || {},
    alias: indexyhDiwH28E7Meta?.alias || [],
    redirect: indexyhDiwH28E7Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexejKMk7xlgoMeta?.name ?? "profile-orders",
    path: indexejKMk7xlgoMeta?.path ?? "/profile/orders",
    meta: indexejKMk7xlgoMeta || {},
    alias: indexejKMk7xlgoMeta?.alias || [],
    redirect: indexejKMk7xlgoMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexq7YnPQbEg4Meta?.name ?? "recently",
    path: indexq7YnPQbEg4Meta?.path ?? "/recently",
    meta: indexq7YnPQbEg4Meta || {},
    alias: indexq7YnPQbEg4Meta?.alias || [],
    redirect: indexq7YnPQbEg4Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93poC5JwtBGOMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93poC5JwtBGOMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93poC5JwtBGOMeta || {},
    alias: _91_46_46_46slug_93poC5JwtBGOMeta?.alias || [],
    redirect: _91_46_46_46slug_93poC5JwtBGOMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexmYV1DtVu0vMeta?.name ?? "wishlist",
    path: indexmYV1DtVu0vMeta?.path ?? "/wishlist",
    meta: indexmYV1DtVu0vMeta || {},
    alias: indexmYV1DtVu0vMeta?.alias || [],
    redirect: indexmYV1DtVu0vMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20261009132434/pages/wishlist/index.vue").then(m => m.default || m)
  }
]